<template>
    <section>
        <div id="sessao-vigencia">
            <div class="row">
                <div class="col-xs-12">
                    <h3><icon name="calendar"></icon> Vigência</h3>
                </div>
                <input type="hidden" name="quotation_date" v-model="dataQuotation.quotation_date">
                <div class="col-xs-12 col-md-6">
                    <div class="form-group" :class="{'has-error': errors.has('data.validity_start')}">
                        <label>Início Vigência <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" name="validity_start" v-mask="'##/##/####'" v-validate="{ rules: { required: true, date_valid: true } }" data-vv-as="Início Vigência" v-model="dataQuotation.validity_start" />
                        <div class="error-message" v-if="errors.has('data.validity_start')">{{ errors.first('data.validity_start') }}</div>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6" v-if="this.$root.$options.config.insureLine !== 'life'">
                    <div class="form-group" :class="{'has-error': errors.has('data.validity_end')}">
                        <label>Fim Vigência <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" name="validity_end" v-mask="'##/##/####'" v-validate="{ rules: { required: true, date_valid: true } }" data-vv-as="Fim Vigência" v-model="dataQuotation.validity_end" />
                        <div class="error-message" v-if="errors.has('data.validity_end')">{{ errors.first('data.validity_end') }}</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import moment from 'shared/helpers/moment'

    export default {
        props: {dataQuotation:Object},
        data(){
            return {
            }
        },
        computed: {
            quotation(){
                return this.$store.getters['quotation']
            }
        },
        watch: {
            'dataQuotation.validity_start': function(value) {
                if(moment(value, 'DD/MM/YYYY', true).isValid()) {
                    this.dataQuotation.validity_end = moment(value, 'DD/MM/YYYY').add(1, 'years').calendar()
                }
            },
            quotation(quotation){
                if(!quotation.data.data.quotation_date || !quotation.data.data.validity_start || !quotation.data.data.validity_end )
                    return

                this.dataQuotation.validity_start = moment(quotation.data.data.validity_start, 'YYYY-MM-DD').format('DD/MM/YYYY')
                this.dataQuotation.quotation_date = moment(quotation.data.data.quotation_date, 'YYYY-MM-DD').format('DD/MM/YYYY')

                this.$nextTick(() => {
                    this.dataQuotation.validity_end = moment(quotation.data.data.validity_end, 'YYYY-MM-DD').format('DD/MM/YYYY')
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// FormPartialQuotation.vue?6ae17060